import { GuaranteeDecision, V2PrescriptionModel } from '@lib/guarantees/data-access';

import { DECISION_REASON_LABEL_KEY } from './guarantee-vocabulary';

/** A note recorded against one line, named by what it explains rather than by which field held it. */
export interface RecordedNote {
  key: string;
  labelKey: string;
  text: string;
  /** The ruling the note was given with. Absent on a note about the line rather than its cover. */
  decision?: GuaranteeDecision;
}

/**
 * Every reason a line carries, each tied to the state it explains. A refusal, an edit and a
 * completion can all be recorded at once, so this is a list rather than one note.
 *
 * Read the same way wherever notes are shown — beside one line, or gathered across a whole visit —
 * because a note that reads differently in two places is a note nobody trusts.
 */
export function recordedNotesOf(prescription: V2PrescriptionModel): RecordedNote[] {
  const notes: RecordedNote[] = [];
  const decision = prescription.decision?.decision ?? GuaranteeDecision.Pending;

  // The reason names a code and the note qualifies it; either alone is the whole explanation.
  const decisionText = [prescription.decision?.reason?.name, prescription.decision?.note].filter(part => !!part?.trim()).join(' — ');
  if (decisionText) {
    notes.push({ key: `${prescription.id}:decision`, labelKey: DECISION_REASON_LABEL_KEY[decision], text: decisionText, decision });
  }

  if (prescription.editReason?.trim()) {
    notes.push({ key: `${prescription.id}:edit`, labelKey: 'guaranteeV2.label.editReason', text: prescription.editReason });
  }

  if (prescription.completionReason?.trim()) {
    notes.push({ key: `${prescription.id}:completion`, labelKey: 'guaranteeV2.label.completionReason', text: prescription.completionReason });
  }

  return notes;
}
